import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProgressionResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("progressions");
  }
  getByFeatureIdAsync(workspaceId, featureId) {
    return this._get(
      buildOdataQuery(
        {
          filter: `ExperimentOperationSet/Feature/Id eq ${featureId}`
        },
        {
          baseUrl: this.getResourceUrl(workspaceId),
          additionalQueryParams: this.getDefaultQueryParams()
        }
      )
    );
  }
};
ProgressionResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ProgressionResource);
const ProgressionResourceInstance = new ProgressionResource();
export {
  ProgressionResource,
  ProgressionResourceInstance as default
};
//# sourceMappingURL=Progression.resource.js.map
